import Vue from 'vue';
import App from './App.vue';
import router from "./app/router";
import store from "./store";

// import '@/assets/js/vue-meta.min.js';
// import VueMeta from 'vueMeta'
import VueMeta from 'vue-meta';
Vue.use(VueMeta);

import "./assets/sass/site.scss";

Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')
